module.exports = __webpack_public_path__ + "static/media/p_heyzoo.9a5d9a14.png";